export const VALIDATED_AGE_BUCKET_COLORS = [
  "#CCEEE7",
  "#E3D6F5",
  "#B597E0",
  "#B6CFE9",
  "#FAD9A8",
  "#F4B5B8",
];

/** Age bucket ids (dueRange) + chart legend labels — validated pending billing */
export const VALIDATED_PENDING_AGE_BUCKETS = [
  { id: "0-30", label: "0 - 30" },
  { id: "31-60", label: "31 - 60" },
  { id: "61-90", label: "61 - 90" },
  { id: "90-120", label: "90 - 120" },
  { id: "120-150", label: "120 - 150" },
  { id: "150+", label: "150+ days" },
];

export const SCRAP_DASHBOARD_TYRE_STATUS_OPTIONS = [
  { value: "ALL", label: "All" },
  { value: "SCRAP", label: "Scrap" },
  { value: "CASING", label: "Casing" },
];

/** True when a tyre-status label denotes scrap rather than a casing grade. */
export const isScrapTyreStatus = (status) =>
  typeof status === "string" && status.trim().toLowerCase() === "scrap";

export const resolveCasingTypeDisplay = (value, isScrap) =>
  value !== null && value !== undefined && value !== ""
    ? value
    : isScrap
    ? "SRP"
    : "-";

export const VALIDATED_PENDING_DETAIL_MODAL_COLUMNS = [
  { key: "zoneName", label: "Zone" },
  { key: "regionName", label: "Region" },
  { key: "hubName", label: "Hub Name" },
  { key: "stencilNo", label: "Stencil No." },
  { key: "lastInspectionDate", label: "Last Insp. Date" },
  { key: "tubeType", label: "Tube Type/Tubeless" },
  { key: "casingType", label: "Casing Type" },
  { key: "validationDate", label: "Validation Date" },
  { key: "validatedBy", label: "Validated By" },
  { key: "dueDays", label: "Due days" },
];

export const BILLED_LIFTED_DETAIL_MODAL_COLUMNS = [
  { key: "zoneName", label: "Zone" },
  { key: "regionName", label: "Region" },
  { key: "hubName", label: "Hub Name" },
  { key: "stencilNo", label: "Stencil No." },
  { key: "lastInspectionDate", label: "Last Insp. Date" },
  { key: "soldOutDate", label: "Sold Out Date" },
  { key: "productType", label: "Tube Type/Tube less" },
];

export const BILLED_LIFTED_STACK_COLORS = {
  srp: "#E9DFFA",
  cs1: "#6928DB",
};

export const SCRAPPED_CASING_DETAIL_MODAL_COLUMNS = [
  { key: "Zone", label: "Zone" },
  { key: "Region", label: "Region" },
  { key: "Hub Name", label: "Hub Name" },
  { key: "stencilNo", label: "Stencil No." },
  { key: "productType", label: "Tube Type/Tube less" },
  { key: "LastInspectionDate", label: "Last Insp. Date" },
  { key: "DueDays", label: "Due Days" },
];

export const SCRAP_ANALYSIS_FLEET_WISE_DETAIL_COLUMNS = [
  { key: "zone", label: "Zone" },
  { key: "region", label: "Region" },
  { key: "hubName", label: "Hub Name" },
  { key: "stencilNo", label: "Stencil No." },
  { key: "lastInspDate", label: "Last Insp. Date" },
  { key: "tubeType", label: "Tube Type/Tube less" },
  { key: "scrapReason", label: "Scrap Reason" },
  { key: "validationDate", label: "Validation Date" },
  { key: "validatedBy", label: "Validated By" },
];

export const SCRAP_TYRE_KM_REPORT_DETAIL_COLUMNS = [
  { key: "zone", label: "Zone", align: "left" },
  { key: "region", label: "Region", align: "left" },
  { key: "hubName", label: "Hub Name", align: "left" },
  { key: "stencilNo", label: "Stencil No.", align: "left" },
  { key: "lastInspDate", label: "Last Insp. Date", align: "left" },
  { key: "tubeType", label: "Tube Type/Tube less", align: "left" },
  { key: "scrapReason", label: "Scrap Reason", align: "left" },
  { key: "validationDate", label: "Validation Date", align: "left" },
  { key: "validatedBy", label: "Validated By", align: "left" },
];

export const VALIDATED_TYRES_RESOURCE_DETAIL_COLUMNS = [
  { key: "zoneName", label: "Zone", align: "left" },
  { key: "regionName", label: "Region", align: "left" },
  { key: "hubName", label: "Hub Name", align: "left" },
  { key: "stencilNo", label: "Stencil No.", align: "left" },
  { key: "casingType", label: "Casing Type", align: "left" },
  { key: "tyreValidationDate", label: "Validation Date", align: "left" },
  { key: "validatedBy", label: "Validated By", align: "left" },
];

export const VALIDATED_TYRES_MODAL_DETAIL_COLUMNS = [
  { key: "zoneName", label: "Zone", align: "left" },
  { key: "regionName", label: "Region", align: "left" },
  { key: "hubName", label: "Hub Name", align: "left" },
  { key: "stencilNo", label: "Stencil No.", align: "left" },
  { key: "tyreValidationDate", label: "Validation Date", align: "left" },
  { key: "casingType", label: "Casing Type", align: "left" },
  { key: "validatedBy", label: "Validated By", align: "left" },
];

export const MONTH_OPTIONS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const kmOptions = [
  { label: "<= 15K KM", value: "15000" },
  { label: "<= 25K KM", value: "25000" },
  { label: "<= 75K KM", value: "75000" },
  { label: "<= 1Lakh KM", value: "100000" },
  { label: "> 1Lakh KM", value: "100001" },
];

/** Column order for scrap/casing tyre Excel export (matches API keys; S.No added in export). */
export const SCRAP_CASING_TYRE_EXPORT_COLUMN_KEYS = [
  "Zone",
  "Region",
  "Fleet Name",
  "Hub Name",
  "Stencil No",
  "Tyre Company",
  "Brand",
  "Tube Type/Tube less",
  "Tyre Size",
  "Material Number",
  "Application Type",
  "Position",
  "Fitment Km",
  "ITM",
  "KM Covered",
  "Projection KM",
  "Contract Type",
  "Casing Type",
  "Tyre Type",
  "Tyre Location",
  "Scrap Reason",
  "RTD1",
  "RTD2",
  "RTD3",
  "IP Psi",
  "Original NSD",
  "G1NSD",
  "G2NSD",
  "G3NSD",
  "G4NSD",
  "Avg NSD",
  "Fitment Date",
  "Last Insp Date",
  "Validation Date",
  "Validated By",
  "validated",
  "SOLD",
  "Sold Date",
  "Due Days",
];
